/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IProcessActionSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.ProcessActionWorkflowBlock;
        processActions: Wars.Domain.Model.ProcessAction[];
        processConfigId: string,
        processActionId: string,
        isReadonly: boolean;
        openOutputOrderModal: () => void;
        processActionChanged: () => void;
    }

    export class ProcessActionSettingsModalController extends BaseModalController {
        scope: IProcessActionSettingsModalControllerScope;

        constructor(
            $scope: IProcessActionSettingsModalControllerScope,
            processActionService: services.ProcessActionService,
            workflowBlock: models.ProcessActionWorkflowBlock,
            processConfigId: string,
            processActionId: string,
            isReadonly: boolean,
            workflowService: services.WorkflowService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.processConfigId = processConfigId;
            this.scope.processActionChanged = () => this.scope.workflowBlock.componentId = this.scope.workflowBlock.processActionDto.processActionId;


            processActionService.getAllProcessActions(processConfigId).then(
                (processActions) => {
                    this.scope.processActions = Enumerable.from(processActions).where(i => i.id !== processActionId).toArray();
                });
            this.scope.isReadonly = isReadonly;

            this.scope.openOutputOrderModal = () => {
                workflowService.showOutputOrderModal(this.scope.workflowBlock, this.scope.isReadonly);
            }
        }
    }
}

warsApp.registerController('ProcessActionSettingsModalController', ['$scope', 'processActionService', 'workflowBlock', 'processConfigId', 'processActionId', 'isReadonly', 'workflowService', 'close']);